import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { TraderModel } from './types'

interface TraderState {
  trader: TraderModel | null
  loading: boolean
  error: string | null
  isVerified: boolean
}

const initialState: TraderState = {
  trader: null,
  loading: false,
  error: null,
  isVerified: false,
}

const traderSlice = createSlice({
  name: 'trader',
  initialState,
  reducers: {
    fetchTraderStart: (state) => {
      state.loading = true
      state.error = null
    },
    fetchTraderSuccess: (state, action: PayloadAction<TraderModel>) => {
      state.trader = action.payload
      state.loading = false
      state.isVerified = action.payload.isVerified
    },
    fetchTraderFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
  },
  selectors: {
    selectTrader: (state) => state.trader,
    selectIsTraderLoading: (state) => state.loading,
    selectIsTraderVerified: (state) => state.isVerified,
    selectTraderError: (state) => state.error,
  },
})

export const { fetchTraderStart, fetchTraderSuccess, fetchTraderFailure } = traderSlice.actions
export const { selectIsTraderVerified, selectTrader, selectTraderError, selectIsTraderLoading } =
  traderSlice.selectors
export default traderSlice.reducer
